export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_01.1dfc0e5c.jpg";